import { useEffect, useState } from "react";
import {
  useGetWorkflowDashboard,
  useGetWorkflowThreshold,
  useUpdateDashboardThreshold,
} from "../api/WorkflowApi";
import { WorkflowStatusBucket } from "../api/Workflows";
import PageHeader from "../shared-components/PageHeader";
import Dashboard from "./Dashboard";
import { ArrowPathIcon as RefreshIcon } from "@heroicons/react/24/outline";
import { format } from "date-fns";
import { useQueryClient } from "react-query";

const WorkflowsDashboard = () => {
  const [lastLoadTimestamp, setLastLoadTimestamp] = useState<Date | number>();

  const {
    data: DashboardData,
    mutate: getWorkflowDashboard,
    isLoading: isDashboardLoading,
  } = useGetWorkflowDashboard();
  const client = useQueryClient();

  const {
    isLoading: isThresholdLoading,
    data: thresholdData,
    mutate: getThresholdDashboard,
  } = useGetWorkflowThreshold();

  const { isLoading: isDashboardThresholdLoading } =
    useUpdateDashboardThreshold();

  useEffect(() => {
    if (!isDashboardThresholdLoading) {
      getThresholdDashboard();
    }
  }, [getThresholdDashboard, isDashboardThresholdLoading]);

  useEffect(() => {
    getWorkflowDashboard();
  }, [getWorkflowDashboard]);

  useEffect(() => {
    if (!isDashboardLoading) {
      setLastLoadTimestamp(Date.now());
    }
  }, [isDashboardLoading]);

  const reload = (e: any) => {
    getWorkflowDashboard();
    client.invalidateQueries({ queryKey: ["reportsSummarByStepNameList"] });
  };

  return (
    <>
      <PageHeader>
        <div className="flex flex-col">
          <h2 className="text-slate-900 text-2xl font-extrabold tracking-tight py-4">
            Report Count By Status
          </h2>
          <p className="text-sm">The table is organized by UTC timestamps.</p>
        </div>
        <div className="flex justify-center items-center">
          {!isDashboardLoading && (
            <div className="p-3 flex flex-row ">
              <RefreshIcon
                onClick={reload}
                className="text-green-600 w-5 cursor-pointer"
              />
              {lastLoadTimestamp && (
                <span className="p-3 text-sm">
                  Last Updated {format(lastLoadTimestamp, "hh:mm a")}
                </span>
              )}
            </div>
          )}
        </div>
      </PageHeader>

      <Dashboard
        isLoading={
          isDashboardThresholdLoading ||
          isThresholdLoading ||
          isDashboardLoading
        }
        header={WorkflowStatusBucket}
        data={DashboardData}
        threshold={thresholdData}
        days={5}
        total={true}
      />
    </>
  );
};

export default WorkflowsDashboard;
